// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__4Mzsc","modalHeader":"modal_modalHeader__WX4La","concise":"modal_concise__LZUAu","modalContent":"modal_modalContent__ckJh+","title":"modal_title__O-aQ8"};